var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "collaborators__panel" },
    [
      _c("div", { staticClass: "collaborators__panel-head" }, [
        _c("div", { staticClass: "collaborators-width" }, [
          _c(
            "div",
            [
              _c(
                "v-btn",
                {
                  staticClass: "collaborators__edit-link",
                  on: {
                    click: function($event) {
                      _vm.prevPage()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("icon-ic-flecha-izquierda")])],
                1
              ),
              _c("h3", [
                _vm._v(_vm._s(_vm.titlePrincipal)),
                _c("span", [_vm._v(_vm._s(_vm.typeState))])
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "collaborators__panel--edit" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "collaborators__edit-link margin-left",
                  on: {
                    click: function($event) {
                      _vm.openEdit()
                    }
                  }
                },
                [_vm._v("Editar")]
              )
            ],
            1
          )
        ])
      ]),
      _c(
        "div",
        { staticClass: "collaborators__panel-body" },
        [
          _c("div", { staticClass: "collaborators-width" }, [
            _c(
              "div",
              { staticClass: "collaborators__title" },
              [
                _c("h3", [_vm._v(_vm._s(_vm.collaboratorsTitle))]),
                _c(
                  "v-layout",
                  { staticClass: "justify-end" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "v-btn--light uppercase",
                        attrs: { small: "" },
                        on: {
                          click: function($event) {
                            _vm.openNewItem2()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.buttonNewChargeSeller))]
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "primary-button uppercase ml-2",
                        attrs: { small: "" },
                        on: {
                          click: function($event) {
                            _vm.openNewItem()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.buttonNewCollaborator))]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._l(_vm.list, function(boss, index) {
            return _c("ListItem", {
              key: index,
              ref: "listItem",
              refInFor: true,
              attrs: {
                team: boss,
                index: boss.value,
                completeFields: true,
                withSearchBox: true,
                typeOfTable: { typeOfTable: _vm.typeOfTable },
                withCompleteTableFields: true,
                additionButtonVisibility: true
              },
              on: {
                editThisChannel: function($event) {
                  _vm.editThisChannel(boss)
                },
                editTeamModal: _vm.editTeamModal,
                showChannels: function($event) {
                  _vm.showChannels(boss.value)
                },
                closeChannels: function($event) {
                  _vm.closeChannels(boss.value)
                },
                editSellerTable: _vm.editSellerTable,
                addNewItem: function($event) {
                  _vm.addNewItem(boss)
                }
              }
            })
          }),
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.conditionalNotContent,
                  expression: "conditionalNotContent"
                }
              ],
              staticStyle: { "text-align": "center" }
            },
            [_vm._v(_vm._s(_vm.messageNotContent))]
          ),
          _c("editChannelModal", {
            ref: "editChannelModal",
            on: {
              completeForm: _vm.completeForm,
              toTeamsTable: _vm.toTeamsTable,
              upDateTeam: _vm.upDateTeam
            }
          }),
          _c("newTeamModal", {
            ref: "newTeamModal",
            on: {
              completeForm: _vm.completeForm,
              upDateTeam: _vm.upDateTeam,
              notShowContent: _vm.notShowContent
            }
          }),
          _c("newSellerModal", {
            ref: "newSellerModal",
            on: {
              completeForm: _vm.completeForm,
              updateShowChannels: _vm.updateShowChannels
            }
          }),
          _c("chargeSellerModal", {
            ref: "chargeSellerModal",
            on: { registerFile: _vm.registerFile }
          }),
          _c("alertModal", { ref: "alertModal" })
        ],
        2
      ),
      _c("loader", { ref: "loaderModal", attrs: { text: _vm.loaderText } }),
      _c("errorFileModal", { ref: "errorFileModal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-86e49ffe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86e49ffe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bosses/channel/_id/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-86e49ffe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bosses/channel/_id/index.vue
// module chunks = 4